import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RECEPTACLE_OVERVIEW.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RECEPTACLE_OVERVIEW.isLoading;

export const getData =
  ReportDefinitions.RECEPTACLE_OVERVIEW.getDataFunction();
